<app-title-section></app-title-section>

<div class="card"  style="margin-left: 15px; margin-right: 15px; height: calc(100vh - 140px); display: flex; flex-direction: column;">
    <app-compte-bancaire [showExtraEdit]="true"
                         [showStatusSwitch]="false"
                         [showDate]="false"
                         [showSolde]="true"
                         style="margin-top: 24px"
    ></app-compte-bancaire>

</div>

